//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    clearInfo: function clearInfo() {
      this.delUrlParams('vuid');
      this.delUrlParams('head');
      this.delUrlParams('nick');
      this.delUrlParams('type');
      this.delUrlParams('from');
    }
  }
};